import React, { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import cn from 'classnames'

import styles from './styles.module.scss'

import TrashIcon from '../Icons/TrashIcon'
import SaveModal from './SaveModal'

import { getUserFilters, saveUserFilters, updateUserFilters, updateUserFiltersStatus, deleteUserFilters } from '../../api'

const StarIcon = ({active, ...props}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 24 24"
      fill="none"
      stroke={active ? '#ffb900' : '#cad5e2'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      aria-hidden="true"
      {...props}
    >
      <path fill={active ? '#ffb900' : 'none'} d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
    </svg>
  )
}

const ChevronIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 24 24"
      fill="none"
      stroke="#cad5e2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      aria-hidden="true"
      {...props}
    >
      <path d="m6 9 6 6 6-6" />
    </svg>
  )
}

const PlusIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      aria-hidden="true"
      {...props}
    >
      <path d="M5 12h14M12 5v14" />
    </svg>
  )
}

const CheckIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      aria-hidden="true"
      {...props}
    >
      <path d="M20 6 9 17l-5-5" />
    </svg>
  )
}

const FvoriteFilters = ({companyId, type, currentFilters, onChangeActive, style, fullWidth, leftOffset = 144}) => {

  const { t } = useTranslation()

  const [actionMenuPosition, setActionMenuPosition] = useState({top: 0, left: 0})
  const [open, setOpen] = useState(false)
  const [userFilters, setUserFilters] = useState([])
  const [active, setActive] = useState(false)

  const saveModalRef = useRef(null)

  const activeFilter = userFilters.find((item) => item.active)

  useEffect(() => {
    const handleDocumentClick = (e) => {
      if (e.target instanceof Element && (e.target.closest('[data-action-menu]') || e.target.closest('[data-action-menu-popover]'))) {
        return
      }

      setOpen(false)
    }

    const handleWindowResize = () => {
      setOpen(false)
    }

    document.addEventListener('click', handleDocumentClick)
    window.addEventListener('resize', handleWindowResize)
    window.addEventListener('scroll', handleWindowResize, true)

    return () => {
      document.removeEventListener('click', handleDocumentClick)
      window.removeEventListener('resize', handleWindowResize)
      window.removeEventListener('scroll', handleWindowResize, true)
    }
  }, [])

  useEffect(() => {
    setTimeout(() => {
      setActive(true)
    }, 1000)
    
  }, [companyId])

  useEffect(() => {
    if (active && companyId) {
      getFilters().then(res => {
        if (res) {
          onChangeActive(res.find((item) => item.active)?.data || {})
        }
      })
    }
  }, [companyId, active])

  const getFilters = async () => {
    const res = await getUserFilters(companyId, type)
    if (Array.isArray(res)) {
      setUserFilters(res)
      return res
    }
    return null
  }

  const handleToggleActionMenu = (e) => {
    console.log('handleToggleActionMenu')
    e.stopPropagation()
    const rect = e.currentTarget.getBoundingClientRect()
    setActionMenuPosition({
      top: rect.bottom + 6,
      left: rect.right - leftOffset,
    })
    setOpen(prev => !prev)
  }

  const handleMenuAction = (e, action) => {
    e.stopPropagation()
    setOpen(false)
    action()
  }

  const handleCreateFilter = async () => {
    const result = await saveModalRef.current.show()
    if (result.success) {
      const post = {
        ...result.data,
        data: currentFilters,
        type: type,
      }
      const res = await saveUserFilters(companyId, post)
      if (res) {
        getFilters()
      }
    }
  }

  const handleUpdateFilter = (id, data) => async (e) => {
    return
    e.stopPropagation()
    const res = await updateUserFilters(companyId, id, {...data, type: type})
    if (res) {
      getFilters()
    }
  }

  const handleUpdateFilterStatus = (id, data) => async () => {
    const res = await updateUserFiltersStatus(companyId, id, {...data, type: type})
    if (res) {
      getFilters().then(res => {
        if (res) {
          if (data.active) {
            onChangeActive(res.find((item) => item.active)?.data || {})
            return
          }
          onChangeActive({})
        }
      })
    }
  }

  const handleRemoveFilter = (id) => async (e) => {
    e.stopPropagation()
    const res = await deleteUserFilters(companyId, id)
    if (res) {
      getFilters()
    }
  }

  return (
    <div className={cn(styles.container, {[styles.fullWidth]: fullWidth})} style={style} data-action-menu={true}>
      <button type="button" className={styles.button} onClick={handleToggleActionMenu}>
        <StarIcon active={Boolean(activeFilter)} />
        {
          fullWidth
            ? t('Saved filters')
            : null
        }
        <ChevronIcon className={styles.chevronIcon} />
      </button>
      {
        open
          ? <div
                className={styles.actionMenu}
                data-action-menu-popover={true}
                style={{ top: actionMenuPosition.top, left: actionMenuPosition.left }}
              >
                <div className={styles.actionMenuHeader}>
                  { t('Saved filters') }
                </div>
                <button
                  type='button'
                  className={cn(styles.actionMenuItem, styles.saveCurrentFilter)}
                  onClick={e => handleMenuAction(e, handleCreateFilter)}
                >
                  <PlusIcon />
                  {t(`Save current filter`)}
                </button>
                {
                  userFilters.map((item) => {
                    return (
                      <button
                        type='button'
                        key={item.id}
                        className={styles.actionMenuItem}
                        onClick={handleUpdateFilterStatus(item.id, {active: !item.active})}
                      >
                        {
                          item.active
                            ? <CheckIcon />
                            : <div className={styles.favoriteButton} onClick={handleUpdateFilter(item.id, {favorite: !item.favorite})}>
                                <StarIcon active={item.favorite} />
                              </div>
                        }
                        { item.name }
                        <div className={styles.removeButton} onClick={handleRemoveFilter(item.id)}>
                          <TrashIcon width={18} height={18} />
                        </div>
                      </button>
                    )
                  })
                }
                
              </div>
          : null
      }
      <SaveModal ref={saveModalRef} />
    </div>
  )
}

export default FvoriteFilters
